import request from '../../src/state/modules/axios'

export function getJobTypes(){
    return request({
        url: '/api/job-types',
        method: 'get',
    })
}
export function getJobTypeById(data){
    return request({
        url: `/api/job-types/${data.id}`,
        method: 'get',
    })
}

export function addJobTypes(data){
    return request({
        url: '/api/job-types',
        method: 'post',
        data,
    })
}

export function editJobTypes(data){
    return request({
        url: `/api/job-types/${data.id}`,
        method: 'put',
        data,
    })
}

export function deleteJobTypes(data){
    return request({
        url: `/api/job-types/${data.id}`,
        method: 'delete'
    })
}